import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import ReferralCode from '../../components/ReferralCode/ReferralCode'
import RegisterNewAccount from '../../components/RegisterNewAccount/RegisterNewAccount'
import AppDownload from '../../components/AppIcon/AppDownload';
import BIEASESIcon from '../../components/AppIcon/BIEASESIcon';

import './Referral.css';

function Referral() {
  const { t } = useTranslation();

  return (
    <div className="Home">
      <div className='banner'>
        <div className='Home-banner'>
          <BIEASESIcon/>
        </div>
      </div>
      <ReferralCode/>
      <RegisterNewAccount/>
      <div className='Home-container'>
        <AppDownload/>
        <div className='footer'>
          <LanguageSwitcher />
          {t('copyright', { year: new Date().getFullYear() })}
        </div>
      </div>
    </div>
  );
}

export default Referral;